import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { M_PER_NEW_01_Schema } from './M_PER_NEW_01_Schema';
import { mapParamsBySchema } from '../../../../util';
import Global from '../../../../Services/Common/Global';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import { handleQuerySuccess } from '../../../../Hooks/apis/useQuriesSuccess';
import useSearchMutaion from '../../../../Hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';
import { M_PER_NEW_Schema } from '../M_PER_NEW/M_PER_NEW_Schema';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_PER_NEW_01_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['Permit', 'getPerNewR2', params],
    queryFn: () => apiRequest('post', Global.urls.Permit.getPerNewR2, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_PER_NEW_01_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.Permit.getPerNewR3, params);
  }, successOptions);
};

export const useSearch3 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_PER_NEW_01_Schema.mapper.search3,
      context
    );
    return apiRequest('post', Global.urls.Permit.getPerCustomR5, params);
  }, successOptions);
};
export const useSearch4 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_PER_NEW_01_Schema.mapper.search4,
      context
    );
    return apiRequest('post', Global.urls.Permit.getPerCustomR4, params);
  }, successOptions);
};
export const useSave1 = () =>
  useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(
      M_PER_NEW_01_Schema.mapper.save1,
      context
    );

    return apiRequest('post1', Global.urls.Permit.savePerNewU1, payload);
  });
export const useSave2 = () =>
  useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(M_PER_NEW_Schema.mapper.save2, context);
    return apiRequest('post1', Global.urls.Permit.savePerCustomU2, payload);
  });
